<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-dialog
      v-model="add_dialog"
      max-width="900"
      :attach="this.$refs.conductorSection"
      hide-overlay
    >
      <v-card>
        <v-card-title class="headline">
          Asociar Conductor
        </v-card-title>
        <v-container grid-list-md>
          <v-form
            ref="conductorForm"
            v-model="conductorValid"
            lazy-validation
          >
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-combobox class="my-0 py-0"
                  v-model="vivienda_asoc"
                  label="Vivienda"
                  placeholder="Comience a escribir para buscar"
                  :items="viviendas"
                  :loading="viviendaIsLoading"
                  :search-input.sync="viviendaSearch"
                  :hide-no-data="!viviendaSearch"
                  item-text="n_vivienda"
                  item-value="n_vivienda"
                  return-object
                  @change="vivienda_asoc_change($event)"
                />
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-select
                  v-model="tipo"
                  label="Tipo"
                  placeholder = "Seleccione un tipo"
                  :items="tipo_propietario"
                  :disabled="tipo_disabled"
                  @change="tipo_conductor_change($event)"
                />
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-select class="my-0 py-0"
                  v-model="conductor_asoc"
                  label="Conductor"
                  placeholder = "Seleccione un conductor"
                  no-data-text = "Sin información"
                  :disabled="conductor_disabled"
                  :items="conductores"
                />
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            flat="flat"
            @click="clear_conductor_form"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="blue darken-1"
            flat="flat"
            @click="send_conductor_form"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-toolbar flat outlined>
      <v-btn icon :link="false" @click="back">
        <v-icon>fa-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
      <v-spacer/>
      <v-btn color="primary" @click="send_form">
        Guardar
      </v-btn>
    </v-toolbar>
    <v-container grid-list-md fluid >
      <v-alert
        :value="alertDialog"
        :type="alertDialogType"
        outline
      >
        {{ alertDialogMessage }}
      </v-alert>
      <v-layout row wrap>
        <v-flex xs10 sm12 md12>
          <v-form
            ref="form"
            id="vehicle_form"
            v-model="valid"
            lazy-validation
          >
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <strong>Vehículo</strong>
                <v-divider/>
              </v-flex>
              <v-flex xs12 sm3 md3 style="display: none">
                <v-text-field
                  disabled
                  v-model="vehiculo_id"
                  label="id"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="marca"
                  label="Marca"
                  :rules="text_required_rules"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="modelo"
                  label="Modelo"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="anio"
                  label="Año"
                  maxlength="5"
                  counter
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="color"
                  label="Color"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="placas"
                  label="Placas"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="num_serie"
                  label="Número de Serie"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="num_tag"
                  label="Número de Tag"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-textarea class="my-0 py-0"
                  v-model="observaciones"
                  label="Observaciones"
                  no-resize
                  rows="1"
                  :value="observaciones"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap ref="conductorSection">
              <v-flex xs12 sm10 md10 class="text-md-left">
                <strong>Conductor(es)</strong>
                <v-divider/>
              </v-flex>
              <v-flex xs12 sm2 md2 class="text-md-right">
                <v-btn slot="activator" color="primary" dark class="mb-2"
                  @click="append_conductor">Agregar
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12 class="text-md-left">
                <template v-for="(conductor, index) in conductores_asociados">
                  <v-layout row wrap :key="index">
                    <v-flex xs12 sm2 md2>
                      <v-text-field class="my-0 py-0"
                        label="Tipo"
                        v-model="conductor.tipo_name"
                        readonly
                      />
                    </v-flex>
                    <v-flex xs12 sm4 md4>
                      <v-text-field class="my-0 py-0"
                        label="Vivienda"
                        v-model="conductor.n_vivienda"
                        readonly
                      />
                    </v-flex>
                    <v-flex xs12 sm5 md5>
                      <v-text-field class="my-0 py-0"
                        label="Conductor"
                        v-model="conductor.conductor_fullname"
                        readonly
                      />
                    </v-flex>
                    <v-flex xs12 sm1 md1 class="text-md-left">
                      <v-btn slot="activator" color="primary" dark class="my-0 py-0"
                        @click="delete_conductor(index)">Eliminar
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </template>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <strong>Multimedia</strong>
                <v-divider/>
              </v-flex>
              <FotoSubir v-model="vehiculo_foto" :label="'Vehículo'" :value="''"
                :size="'6'" :idImg="'imgFoto'"/>
              <FotoSubir v-model="vehiculo_foto_alt" :label="'Vehículo'" :value="''"
                :size="'6'" :idImg="'imgFotoAlt'"/>
            </v-layout>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import FotoSubir from '@/components/foto_subir.vue';
// eslint-disable-next-line import/no-cycle
import ApiService from '../common/api.service';
import { getJWTData } from '../common/jwt.service';

export default {
  components: {
    FotoSubir,
  },
  data: () => ({
    vehiculo_id: '',
    // vehiculo_info: {},
    tipo_name: '',
    conductor_disabled: true,
    tipo_disabled: true,
    conductor_fullname_asoc: null,
    conductoresApiResult: [],
    tmpConductoresApiResult: [],
    conductores_asociados: [],
    vehiculo_foto: '',
    vehiculo_foto_alt: '',
    label_vivienda_asoc: 'Vivienda',
    vivienda_disabled: true,
    residente_disabled: true,
    viviendaIsLoading: false,
    viviendaSearch: null,
    viviendasApiResult: [],
    viviendaValid: false,
    vivienda_asoc: null,
    residente_asoc: null,
    conductorValid: false,
    conductor_asoc: null,
    residente_fullname_asoc: null,
    valid: true,
    dialog: false,
    processing: false,
    editing: false,
    menu_black_list_desde_fecha: false,
    menu_black_list_desde_hora: false,
    disable_black_list_field: true,
    menu_white_list_desde_fecha: false,
    menu_white_list_desde_hora: false,
    disable_white_list_field: true,
    add_dialog: false,
    residente: null,
    residentValid: true,
    tipoResidente: null,
    residenteIsLoading: false,
    residenteSearch: null,
    residentesApiResult: [],
    vehiculo_socio: '',
    residenteDetailsApiResult: [],
    viviendaDetailsApiResult: [],
    colaboradorDetailsApiResult: [],
    colaboradorIsLoading: false,
    colaboradorSearch: null,
    colaboradoresApiResult: [],
    vehiculo_vivienda: '',
    vehiculo_colaborador: '',
    vehiculo_titular: '',
    vehiculo_conductor: '',
    colaborador_asociado: [],
    headers: [
      { text: 'id', value: 'id', sortable: false },
      { text: 'Marca', value: 'marca', sortable: true },
      { text: 'Modelo', value: 'modelo', sortable: true },
      { text: 'Año', value: 'anio', sortable: true },
      { text: 'Color', value: 'color', sortable: true },
      { text: 'Placas', value: 'placas', sortable: true },
      { text: 'Número de Tag', value: 'num_tag', sortable: true },
      { text: 'Vivienda', value: 'viviendas', sortable: false },
      { text: 'Acciones', value: 'acciones', sortable: false },
    ],
    tipo_propietario: [
      { text: 'Residente', value: 'residente' },
      // { text: 'Socio', value: 'socio' },
      // { text: 'Servicio Doméstico', value: 'servicio_domestico' },
      // { text: 'Colaborador', value: 'colaborador' },
    ],
    text_required_rules: [
      v => !!v || 'Requerido',
    ],
    status_lista: { text: 'NO DEFINIDO', value: 'no_definido' },
    marca: '',
    modelo: '',
    anio: '',
    color: '',
    placas: '',
    num_serie: '',
    num_tag: '',
    tipo: '',
    observaciones: '',
    files: [],
    alertDialogForm: false,
    alertDialogFormType: 'success',
    alertDialogFormMessage: '',
    add_btn: false,
    view_btn: false,
    edit_btn: false,
  }),
  computed: {
    alertType() {
      return this.$store.getters['capturaVehiculos/alertContainerType'];
    },
    alertMessage() {
      return this.$store.getters['capturaVehiculos/alertContainerMessage'];
    },
    alert() {
      return this.$store.getters['capturaVehiculos/alertContainer'];
    },
    alertDialogType() {
      return this.$store.getters['capturaVehiculos/alertDialogType'];
    },
    alertDialogMessage() {
      return this.$store.getters['capturaVehiculos/alertDialogMessage'];
    },
    alertDialog() {
      return this.$store.getters['capturaVehiculos/alertDialog'];
    },
    formTitle() {
      return this.editing === false ? 'Agregar Vehículo' : 'Editar Vehículo';
    },
    is_loading() {
      return this.$store.getters['capturaVehiculos/is_loading'];
    },
    /*
    vehiculo_info() {
      return this.$store.getters['capturaVehiculos/vehiculo_info'];
    },
    */
    vehiculo_processing() {
      return this.$store.getters['capturaVehiculos/vehiculo_processing'];
    },
    vehiculo_submited() {
      return this.$store.getters['capturaVehiculos/vehiculo_submited'];
    },
    viviendas() {
      return this.viviendasApiResult;
    },
    conductores() {
      return this.conductoresApiResult;
    },
  },
  watch: {
    vehiculo_processing(val) {
      this.processing = val;
    },
    viviendaSearch() {
      if (this.viviendas.length > 0) return;
      if (this.viviendaIsLoading) return;
      this.viviendaIsLoading = true;
      ApiService.setHeader();
      ApiService.query('accesos/viviendas')
        .then(({ data }) => {
          this.viviendasApiResult = data.viviendas;
        })
        .catch(({ response }) => {
          console.log(response);
        })
        .finally(() => {
          this.viviendaIsLoading = false;
        });
    },
  },
  methods: {
    back() {
      this.$router.back();
    },
    decode_base64(type, value) {
      let encoded = '';
      let extension = '';
      if (type === 'foto') {
        encoded = this.vehiculo_info.foto;
      } else if (type === 'foto_alt') {
        encoded = this.vehiculo_info.foto_alt;
      } else {
        encoded = value;
      }
      if (typeof encoded === 'string') {
        const check = encoded.substring(0, 3);
        if (check === '/9j') {
          extension = 'jpg';
        } else if (check === 'iVB') {
          extension = 'png';
        } else if (check === 'SUk') {
          extension = 'tiff';
        } else extension = 'bmp'; // Qk0
      } else {
        extension = 'png';
        encoded = 'R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
      }
      return `data:image/${extension};base64,${encoded}`;
    },
    set_tipo_name(tipo) {
      this.tipo_name = '';
      // this.tipo = tipo;
      if (tipo === 'residente') {
        this.tipo_name = 'Residente';
      } else if (tipo === 'servicio_domestico') {
        this.tipo_name = 'Servicio Doméstico';
      }
    },
    clear_null(value) {
      let tmpNull = null;
      if (typeof value === 'string') {
        if (value === 'None') {
          tmpNull = '';
        } else {
          tmpNull = value.trim();
        }
      } else if (value === null || typeof value === 'undefined') {
        tmpNull = '';
      } else {
        tmpNull = value;
      }
      return tmpNull;
    },
    delete_conductor(index) {
      delete this.conductores_asociados.splice(index, 1);
    },
    clear_conductor_form() {
      this.vivienda_asoc = null;
      this.conductor_asoc = null;
      this.conductor_fullname_asoc = null;
      this.tipo = '';
      this.tipo_name = '';
      this.add_dialog = false;
    },
    send_conductor_form() {
      if (this.$refs.conductorForm.validate()) {
        this.set_tipo_name(this.tipo);
        const obj = this.conductores.find(o => o.value === this.conductor_asoc);
        this.conductor_fullname_asoc = obj.text;
        const formdata = {
          vivienda_id: this.vivienda_asoc.id,
          n_vivienda: this.vivienda_asoc.n_vivienda,
          conductor_id: this.conductor_asoc,
          conductor_fullname: this.conductor_fullname_asoc,
          tipo_name: this.clear_null(this.tipo_name),
          tipo: this.clear_null(this.tipo),
        };
        this.conductores_asociados.push(formdata);
        this.clear_conductor_form();
      }
    },
    append_conductor() {
      this.add_dialog = true;
    },
    domestico_concat_fullname(info) {
      this.conductoresApiResult = [];
      info.map((value) => {
        this.conductoresApiResult.push({
          text: `${value.nombres} ${this.clear_null(value.apellido_paterno)} ${this.clear_null(value.apellido_materno)}`.trim(),
          value: value.id,
        });
      });
      this.conductor_asoc = this.conductoresApiResult[0].value;
      this.conductor_fullname_asoc = this.conductoresApiResult[0].text;
    },
    residente_concat_fullname(info) {
      this.conductoresApiResult = [];
      info.map((value) => {
        this.conductoresApiResult.push({
          text: `${value.residente.nombres} ${this.clear_null(value.residente.apellido_paterno)} ${this.clear_null(value.residente.apellido_materno)}`.trim(),
          value: value.residente_id,
        });
      });
      this.conductor_asoc = this.conductoresApiResult[0].value;
      this.conductor_fullname_asoc = this.conductoresApiResult[0].text;
    },
    /*
    conductor_asoc_change(event) {
      console.log('conductor_asoc_change');
      this.conductor_asoc_info(event);
    },
    */
    vivienda_asoc_change(event) {
      this.tipo = '';
      this.tipo_disabled = false;
      this.conductor_disabled = true;
      this.residenteIsLoading = true;
      this.conductoresApiResult = [];
      this.tmpConductoresApiResult = [];
      if (typeof event === 'object' && this.clear_null(event) !== '') {
        ApiService.setHeader();
        ApiService.query(`accesos/viviendas/${event.id}`)
          .then(({ data }) => {
            if (data.vivienda.residentes.length > 0 || data.vivienda.domesticos.length > 0) {
              if (data.vivienda.residentes.length > 0) {
              // this.tmpConductoresApiResult.push({ residentes: data.vivienda.residentes });
                this.tmpConductoresApiResult.residentes = data.vivienda.residentes;
              }
              if (data.vivienda.domesticos.length > 0) {
              // this.tmpConductoresApiResult.push({ domesticos: data.vivienda.domesticos });
                this.tmpConductoresApiResult.domesticos = data.vivienda.domesticos;
              }
            } else {
              console.log(data.vivienda);
            }
            console.log(this.tmpConductoresApiResult);
          })
          .catch(({ response }) => {
            console.log(response);
            this.residente_disabled = true;
          })
          .finally(() => {
            this.residenteIsLoading = false;
          });
      } else {
        this.residente_disabled = true;
      }
    },
    tipo_conductor_change(event) {
      this.conductor_disabled = false;
      if (event === 'residente' && this.tmpConductoresApiResult.residentes !== undefined) {
        this.residente_concat_fullname(this.tmpConductoresApiResult.residentes);
      } else if (event === 'servicio_domestico' && this.tmpConductoresApiResult.domesticos !== undefined) {
        this.domestico_concat_fullname(this.tmpConductoresApiResult.domesticos);
      }
    },
    setVehiculoColaboradorInfo() {
      if (this.$refs.colaboradorForm.validate()) {
        const formdata = {
          colaborador_id: this.vehiculo_colaborador.colaborador_id,
        };
        if (this.editing) {
          formdata.vehiculo_id = this.vehiculo_id;
        }
        this.colaborador_asociado = formdata;
        this.vehiculo_colaborador = null;
        this.add_dialog = false;
      }
    },
    setVehiculoResidenteInfo() {
      if (this.$refs.residentForm.validate()) {
        const formdata = {
          vivienda_id: this.vehiculo_vivienda.id,
          titular_id: this.vehiculo_titular,
          conductor_id: this.vehiculo_conductor,
        };
        if (this.editing) {
          formdata.vehiculo_id = this.vehiculo_id;
        }
        this.conductores_asociados = formdata;
        this.vehiculo_vivienda = null;
        this.vehiculo_titular = '';
        this.vehiculo_conductor = '';
        this.add_dialog = false;
      }
    },
    close_add_dialog() {
      this.add_dialog = false;
      this.alertDialogForm = false;
      this.alertDialogFormType = 'success';
      this.alertDialogFormMessage = '';
      this.tipo = '';
      this.viviendasApiResult = [];
      this.viviendaDetailsApiResult = [];
      this.colaboradorDetailsApiResult = [];
      this.conductores_asociados = [];
      this.vehiculo_vivienda = null;
      this.vehiculo_titular = '';
      this.vehiculo_conductor = '';
      this.vehiculo_colaborador = '';
      this.colaborador_asociado = [];
      this.conductoresApiResult = [];
      this.tmpConductoresApiResult = [];
    },
    conductores_asociados_info(conductores) {
      let i;
      for (i = 0; i < conductores.length; i++) {
        if (conductores[i].tipo === 'residente') {
          this.tmpConductorId = conductores[i].residente_id;
        } else {
          this.tmpConductorId = conductores[i].domestico_id;
        }
        this.tmpComductorFullname = `${this.clear_null(conductores[i].nombre)} ${this.clear_null(conductores[i].apellidos)}`.trim();
        this.set_tipo_name(conductores[i].tipo);
        const formdata = {
          vivienda_id: conductores[i].vivienda_id,
          n_vivienda: conductores[i].vivienda_n,
          conductor_id: this.tmpConductorId,
          conductor_fullname: this.tmpComductorFullname,
          tipo_name: this.tipo_name,
          tipo: conductores[i].tipo,
        };
        this.conductores_asociados.push(formdata);
      }
      // this.vehiculo_info.asignaciones = this.conductores_asociados;
    },
    init_edit_data(data) {
      // console.log(data);
      this.vehiculo_id = data.vehiculo_id;
      this.marca = data.marca;
      this.modelo = data.modelo;
      this.anio = data.anio;
      this.color = data.color;
      this.placas = data.placas;
      this.num_serie = data.num_serie;
      this.num_tag = data.num_tag;
      this.observaciones = data.observaciones;
      // this.conductores_asociados = [...data.asignaciones];
      const tmpConductores = [...data.asignaciones];
      this.conductores_asociados_info(tmpConductores);
      if (data.foto !== null) {
        this.vehiculo_foto = data.foto;
        const imageToShow = document.getElementById('imgFoto');
        imageToShow.src = this.decode_base64('', this.vehiculo_foto);
      }
      if (data.foto_alt !== null) {
        this.vehiculo_foto_alt = data.foto_alt;
        const imageToShow = document.getElementById('imgFotoAlt');
        imageToShow.src = this.decode_base64('', this.vehiculo_foto_alt);
      }
    },
    edit_vehicle(vehiculo) {
      this.editing = true;
      this.$store.dispatch('capturaVehiculos/fetchVehiculoInfo', vehiculo);
      this.dialog = true;
    },
    send_form() {
      if (this.processing === true) {
        return;
      }
      if (this.$refs.form.validate()) {
        this.$store.commit('capturaVehiculos/startedVehiculoProcessing');
        const formdata = new FormData();
        formdata.set('marca', this.clear_null(this.marca));
        formdata.set('modelo', this.clear_null(this.modelo));
        formdata.set('anio', this.clear_null(this.anio));
        formdata.set('color', this.clear_null(this.color));
        formdata.set('placas', this.clear_null(this.placas));
        formdata.set('num_serie', this.clear_null(this.num_serie));
        formdata.set('num_tag', this.clear_null(this.num_tag));
        // formdata.set('tipo', this.clear_null(this.tipo));
        formdata.set('observaciones', this.clear_null(this.observaciones));
        formdata.set('conductores_asociados', JSON.stringify(this.conductores_asociados));
        if (this.vehiculo_foto.length !== 0) {
          if (this.vehiculo_foto.includes('base64')) {
            formdata.set('vehiculo_foto', this.vehiculo_foto.split(',')[1]);
          } else {
            formdata.set('vehiculo_foto', this.vehiculo_foto);
          }
        }
        if (this.vehiculo_foto_alt.length !== 0) {
          if (this.vehiculo_foto_alt.includes('base64')) {
            formdata.set('vehiculo_foto_alt', this.vehiculo_foto_alt.split(',')[1]);
          } else {
            formdata.set('vehiculo_foto_alt', this.vehiculo_foto_alt);
          }
        }
        if (this.editing) {
          formdata.set('vehiculo_id', this.vehiculo_id);
        }
        // console.log(Object.fromEntries(formdata));
        
        this.$store.commit('capturaVehiculos/resetVehiculoSubmit');
        this.$store.dispatch('capturaVehiculos/sendVehiculo', formdata);
        // this.$refs.form.reset();
        this.$router.back();
      }
    },
  },
  created() {
  },
  mounted() {
    if ('id' in this.$route.params) {
      this.$store.dispatch('capturaVehiculos/fetchVehiculoInfo', this.$route.params.id).then((data) => {
        // this.vehiculo_info = data.vehiculo;
        this.init_edit_data(data.vehiculo);
      });
      this.editing = true;
    }
  },
};
</script>
